import { render, staticRenderFns } from "./Node.version.1.vue?vue&type=template&id=bffab100&"
import script from "./Node.version.1.vue?vue&type=script&lang=js&"
export * from "./Node.version.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports